module.exports = __webpack_public_path__ + "static/permissions-roles-fd64cb7c669ef9a110b3ced9956d6908.png";